import { styled } from "@mui/material"
import {
  SafeApiComponent,
  useFinancialDataSalesApi,
} from "@pharmupp/p3-front-commons"
import { SummaryInfo } from "../../../common"
import type { PharmacyPeriodFilter } from "../types"

export const SalesSummaryInfo = (props: PharmacyPeriodFilter) => {
  return (
    <SafeApiComponent>
      <SalesSummaryInfoInner {...props} />
    </SafeApiComponent>
  )
}

const SalesSummaryInfoInner = ({ period, pharmacyId }: PharmacyPeriodFilter) => {
  const {
    data: { sources, periodEndDate },
  } = useFinancialDataSalesApi({ period, pharmacyId })

  return <StyledSummaryInfo sources={sources} period={periodEndDate} />
}

const StyledSummaryInfo = styled(SummaryInfo)(({ theme }) => ({
  marginTop: theme.spacing(2),
}))
